// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"605":"430e63e6","784":"245d7a43"}[chunkId] + ".chunk.js";
};